// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breaks-plugin-message {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 25% 0;
    z-index: 100;
    font-size: 40px;
    background-color: rgba(0,0,0,0.6);
    color: white;
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/css/BreaksPlugin.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":[".breaks-plugin-message {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    padding: 25% 0;\n    z-index: 100;\n    font-size: 40px;\n    background-color: rgba(0,0,0,0.6);\n    color: white;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
